import { createFileRoute, Link } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import { FeatureSection } from "@/components/FeatureSection";
import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { SocialButtons } from "@/components/SocialButtons";
import { StickyNav } from "@/components/StickyNav";
import { ButtonLink } from "@/components/ui/button";
import { WhatPeopleAreSaying } from "@/components/WhatPeopleAreSaying";
/* eslint-disable import-x/no-duplicates */
// @ts-expect-error TODO: fix this
import card3 from "@/images/illustration.png?slice=1&height=221&width=506&x=556&y=4805";
// @ts-expect-error TODO: fix this
import card2 from "@/images/illustration.png?slice=1&height=221&width=706&x=531&y=3072";
// @ts-expect-error TODO: fix this
import card1 from "@/images/illustration.png?slice=1&height=321&width=506&x=445&y=966";
// @ts-expect-error TODO: fix this
import card4 from "@/images/illustration.png?slice=1&height=642&width=1506&x=260&y=3400";
// @ts-expect-error TODO: fix this
import textIllustrationDark from "@/images/illustration.png?slice=1&x=203&y=1098&height=551&width=838";
// @ts-expect-error TODO: fix this
import heroIllustration from "@/images/illustration.png?slice=1&x=300&y=0&height=1000&width=1000";
// @ts-expect-error TODO: fix this
import textIllustration from "@/images/illustration.png?slice=1&x=715&y=2722&height=665&width=1250";
/* eslint-enable import-x/no-duplicates */
import { getGlobalStats } from "@/lib/api";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  loader: async () => {
    const globalStats = await getGlobalStats();

    const formmatedUsers = Intl.NumberFormat("en-us", {
      notation: "compact",
      maximumSignificantDigits: 2,
    }).format(globalStats.unique_users);
    const formmatedDelivers = Intl.NumberFormat("en-us", {
      notation: "compact",
      maximumSignificantDigits: 2,
    }).format(globalStats.unique_delivers);

    return {
      formmatedUsers,
      formmatedDelivers,
    };
  },
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Graze: Custom Feed Builder for Bluesky",
      ogTitle: "Bluesky Custom Feeds - Built By You",
      description:
        "Design, deploy, and grow custom feeds of any complexity on Bluesky with Graze.social.",
      pathname,
    }),
});

function RouteComponent() {
  const { formmatedUsers, formmatedDelivers } = Route.useLoaderData();

  return (
    <div>
      <div className="min-h-screen bg-slate-app instrument-sans text-slate-normal">
        <header className="bg-teal-9 dark:bg-tealdark-9">
          <div className="flex items-center gap-12 mx-auto container px-4">
            <div className="h-full items-center justify-center hidden md:flex flex-1 @container">
              <div className="relative flex items-center justify-center">
                <div
                  className="sharp-grotesk text-[100cqw] leading-[0.9] big-g-scroll"
                  style={{
                    backgroundImage: `url('${heroIllustration}')`,
                    backgroundSize: "100cqw",
                    backgroundClip: "text",
                    color: "transparent",
                    textShadow: "none",
                  }}
                >
                  G
                </div>
                <div className="absolute right-[4.5cqw] bottom-[5cqw] text-slate-12 instrument-serif text-[15cqw] italic">
                  Graze
                </div>
              </div>
            </div>
            <div className="flex-1 py-6 md:py-10 flex flex-col @container">
              <div className="flex mb-2 md:mb-8 md:justify-end">
                <MarketingNavBar onlyNav />
              </div>
              <h1 className="text-[14cqw] instrument-serif bold mb-4">
                Own Your Algorithm
              </h1>
              <div className="mb-6 md:mb-8 flex flex-col gap-4 max-w-[68ch] border-2 border-teal-11 dark:border-teald11rk-7 rounded-xl p-4 bg-white/30 dark:bg-black/30">
                <p className="text-xl md:text-2xl font-medium">
                  Build custom social feeds. Grow your audience. Keep the
                  revenue.
                </p>
                <p className="text-lg md:text-xl">
                  Stop letting platforms control your reach. Graze lets you
                  create personalized feeds on ATProto{" —  "}no code required.
                </p>
              </div>
              <div className="flex gap-2">
                <ButtonLink size="lg" to="/login" style={{ fontSize: "1rem" }}>
                  Start building
                </ButtonLink>
                <SocialButtons />
              </div>
            </div>
          </div>
        </header>

        <StickyNav />

        <main>
          <section className="py-6 md:py-16">
          <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              Built For You
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
              <Link
                to="/feed-curators"
                className="cursor-pointer-extra flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 hover:scale-103 transition-transform overflow-hidden border-2 rounded-lg"
              >
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card1}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Feed Curators
                  </div>
                  <div className="text-lg">
                    Turn your expertise into income. Build feeds around your
                    passions and start earning from day one.
                  </div>
                </div>
              </Link>
              <Link
                to="/brands"
                className="cursor-pointer-extra flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 hover:scale-103 transition-transform overflow-hidden border-2 rounded-lg"
              >
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card2}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Brands & Publishers
                  </div>
                  <div className="text-lg">
                    Reach your audience directly. No more algorithm roulette!
                    You control how your content gets discovered.
                  </div>
                </div>
              </Link>
              <Link
                to="/developers"
                className="cursor-pointer-extra flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 hover:scale-103 transition-transform overflow-hidden border-2 rounded-lg"
              >
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card3}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Developers
                  </div>
                  <div className="text-lg">
                    Full API access. Build sophisticated feeds with custom logic
                    and integrations.
                  </div>
                </div>
              </Link>
              <Link
                to="/advertising"
                className="cursor-pointer-extra flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 hover:scale-103 transition-transform overflow-hidden border-2 rounded-lg"
              >
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card4}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Advertisers
                  </div>
                  <div className="text-lg">
                    Connect with engaged audiences through targeted feed
                    sponsorships.
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-slate-4 dark:bg-slatedark-4">
          <div className="container @container mx-auto grid relative z-0 px-4">
            <div
              className={cn([
                "flex flex-col justify-center items-center lg:container mx-auto uppercase gap-4",
                "bg-cover bg-center bg-no-repeat",
                "dark:hidden",
              ])}
              style={{
                backgroundImage: `url('${textIllustration}')`,
                backgroundClip: "text",
                color: "transparent",
                gridColumn: "1 / -1",
                gridRow: "1 / 2",
              }}
            >
              <div className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center">
                6,500 Feeds
              </div>
              <div
                className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center"
                suppressHydrationWarning
              >
                {formmatedUsers} users
              </div>
              <div
                className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center"
                suppressHydrationWarning
              >
                {formmatedDelivers} posts
              </div>
            </div>
            <div
              className={cn([
                "flex-col justify-center items-center lg:container mx-auto uppercase gap-4",
                "bg-cover bg-center bg-no-repeat",
                "hidden dark:flex",
                "text-shadow-[0_0_0_rgba(0,0,0,0.3)]",
              ])}
              style={{
                backgroundImage: `url('${textIllustrationDark}')`,
                backgroundClip: "text",
                color: "transparent",
                gridColumn: "1 / -1",
                gridRow: "1 / 2",
              }}
            >
              <div className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center">
                6,500 Feeds
              </div>
              <div className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center">
                {formmatedUsers} users
              </div>
              <div className="leading-none tracking-wider sharp-grotesk w-full text-[11.1cqw] text-center">
                {formmatedDelivers} posts
              </div>
            </div>
          </div>
        </section>

        <FeatureSection />

        <section className="py-6 md:py-16 bg-slate-3 dark:bg-slatedark-3">
          <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              Real Curator Success
            </h2>
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="shrink-0 md:flex-1 flex items-center bg-teal-11 dark:bg-tealdark-10 text-teal-contrast dark:text-tealdark-contrast @ border-2 border-teal-12 dark:border-tealdark-11 rounded-lg @container">
                <div className="p-8 flex flex-col items-end gap-8">
                  <div className="flex md:flex-col items-center md:items-start gap-8">
                    <div className="shrink-0 h-[100px] w-[100px]">
                      <img
                        src="https://cdn.bsky.app/img/avatar_thumbnail/plain/did:plc:kkf4naxqmweop7dv4l2iqqf5/bafkreicxyrwjzitextucvgfx3mkw4ekpjoctg6mei2btqtwoq7m4l473oi@jpeg"
                        alt=""
                        className="h-full w-full rounded-full border-2"
                      />
                    </div>
                    <div className="text-lg md:text-2xl leading-relaxed">
                      Graze totally changed how I run my feeds. I finally have
                      insight into usage, plus monetization has let me donate
                      over $500 to developers building on Bluesky. Graze is
                      truly Bluesky/ATProto's first killer app.
                    </div>
                  </div>
                  <div className="text-lg md:text-2xl instrument-serif">
                    ~ Ændra,{" "}
                    <a
                      href="https://bsky.app/profile/did:plc:kkf4naxqmweop7dv4l2iqqf5/feed/verified-news"
                      className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                    >
                      Verified News Feed Operator
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-4 md:flex-1">
                <div className="flex flex-col gap-2 bg-orange-10 dark:bg-orangedark-10 text-orange-contrast dark:text-orangedark-contrast border-2 border-orange-11 dark:border-orangedark-11 rounded-lg">
                  <div className="p-8 flex flex-col items-end gap-8">
                    <div className="flex items-center gap-8">
                      <div className="shrink-0 h-[100px] w-[100px]">
                        <img
                          src="https://cdn.bsky.app/img/avatar/plain/did:plc:2c7afebp7enocvuvbp4u5yam/bafkreib2uuh3fvkgpmaue4gac53ihsagj6lpjwbrwyckaiuxgf3pnlpsuy@jpeg"
                          alt=""
                          className="h-full w-full rounded-full border-2"
                        />
                      </div>
                      <div className="md:text-lg leading-relaxed">
                        Graze gave us{" "}
                        <b>
                          a way to experiment with our editorial approach and
                          quickly learn what resonates
                        </b>{" "}
                        without relying on Twitter's or Meta's black box.
                      </div>
                    </div>
                    <div className="md:text-lg instrument-serif">
                      ~ Addison Nugent, Audience Editor at{" "}
                      <a
                        href="https://www.sfstandard.com"
                        className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                      >
                        SF Standard
                      </a>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2 bg-slate-11 dark:bg-slatedark-9 text-slate-contrast dark:text-slatedark-contrast border-2 border-slate-12 dark:border-slatedark-11 rounded-lg">
                  <div className="p-8 flex flex-col items-end gap-8">
                    <div className="flex items-center gap-8">
                      <div className="shrink-0 h-[100px] w-[100px]">
                        <img
                          src="https://cdn.bsky.app/img/avatar/plain/did:plc:qfno2hq7u4n2vrka3iebvexh/bafkreihn2mcydz2pncxglwbapwezwnwzlmebk4fhuymubmntn64s5aeu54@jpeg"
                          alt=""
                          className="h-full w-full rounded-full border-2"
                        />
                      </div>
                      <div className="md:text-lg leading-relaxed">
                        Graze cleanly organized the content we want to highlight
                        into streamlined feeds, making it so much easier for our
                        fans to find music, and directly support artists. Even
                        when we're disorganized, Graze stays on top of things.
                      </div>
                    </div>
                    <div className="md:text-lg instrument-serif">
                      ~ J. Edward Keyes, Senior Editorial Lead @{" "}
                      <a
                        href="https://bandcamp.com"
                        className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                      >
                        Bandcamp
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-8 md:gap-12">
              <WhatPeopleAreSaying />
            </div>
          </div>
          </section>
        </main>

        <MarketingFooter />
      </div>
    </div>
  );
}
